import React, { useState, forwardRef, useImperativeHandle, useEffect } from "react";
import { IconX } from '@tabler/icons-react'

const Record = forwardRef(
  function Record(props, ref) {
    const [title, setTitle] = useState("");
    const [isOpen, setIsOpen] = useState("");
    const [eventDate, setEventDate] = useState("");
    const [eventTime, setEventTime] = useState("");
    const [venue, setVenue] = useState("");
    const [locationUrl, setLocationUrl] = useState("");
    const [errors, setErrors] = useState({});
    const [showDelete, setShowDelete] = useState(false);

    useEffect(() => {
      if (props.data) {
        setTitle(props.data.title);
        setIsOpen(props.data.show);
        setEventDate(props.data.eventDate);

      }
    }, [props.data])

    useEffect(() => {
      setIsOpen(props.data.show);
    }, [props.data.show]);

    useEffect(() => {
      setShowDelete(props.showDelete);
    }, [props.showDelete]);

    const validate = () => {
      const errors = {};

      if (!title || (title && title.trim() == "")) {
        errors.title = "Event name is required";
      }

     
      setErrors(errors);
      return Object.keys(errors).length === 0;
    }

   const getData = () => {
  return [
    {
      title: title,
      description: eventDate,
    }
  ];
};
    useImperativeHandle(ref, () => ({
      getData: getData,
      validate: validate
      
    }));
    return (
      <div className="card accordion-item ">
        <h2 className="accordion-header">
          <button type="button"
            onClick={() => props.showHideEvent(props.index)}
            className={`accordion-button ${isOpen ? "" : "collapsed"}`}>
            {title}
          </button>
        </h2>

        <div className={`accordion-collapse ${isOpen ? "show" : "collapse"}`}>
          <div className="accordion-body mt-3">
            <div className="row">
              <div className="col-lg-8 col-12">
                <div className="row">
                  <div className="col-md-6 mt-2">
                  <label className="form-label" htmlFor="section2Name">
            Video url
              </label>
                    <input
                      type="text"
                      className={`form-control ${errors.title ? "is-invalid" : ""}`}
                      placeholder="Enter your Record Title"
                      value={title}
                      onChange={(e) => setTitle(e.target.value)}
                    />
                    {errors.title && (
                      <div className="invalid-feedback">
                        {errors.title}
                      </div>
                    )}
                  </div>
                  <div className="col-md-6 mt-2">
                  <label className="form-label" htmlFor="section2Name">
            Video description
              </label>
                    <textarea
                      type="text"
                      className={`form-control ${errors.eventDate ? "is-invalid" : ""}`}
                      placeholder="Enter your Record Title"
                      value={eventDate}
                      onChange={(e) => setEventDate(e.target.value)}
                    />
                    {errors.eventDate && (
                      <div className="invalid-feedback">
                        {errors.eventDate}
                      </div>
                    )}
                  </div>
                  
                </div>
              </div>
            </div>
            {showDelete && (
              <div className="col-12 mt-3">
                <button type="button" className="btn btn-label-danger"
                  onClick={() => props.deleteEvent(props.index)}>
                  <IconX className="me-1" size={16} />
                  <span className="align-middle">Delete</span>
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
    )
  });

export default Record;

